module.exports = __webpack_public_path__ + "img/344.7a64e9ce.jpg";